// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemIcmsStColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the ICMS-ST (tax substitution) value column for item subtables.
function itemIcmsStColumn(options = {}) {
  const { size, ..._ } = options;
  const fontSize = resolveItemFontSize(size, 10);
  return {
    title: 'ST',
    dataIndex: ['tax', 'icmsSt', 'value'],
    width: 60,
    align: 'right',
    sorter: (a, b) => {
      const aVal = a?.tax?.icmsSt?.value || a?.icmsSt || 0;
      const bVal = b?.tax?.icmsSt?.value || b?.icmsSt || 0;
      return aVal - bVal;
    },
    render: (_, item) => {
      const icmsSt = item?.tax?.icmsSt?.value || item?.icmsSt;
      if (!icmsSt) {
        return (
          <Text style={{ fontSize }} type="secondary">
            —
          </Text>
        );
      }
      return (
        <Text style={{ fontSize }} type="secondary">
          {financialService.formatCurrency(icmsSt)}
        </Text>
      );
    },
  };
}

export default itemIcmsStColumn;
